import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { PricePolicyApi, PricePolicyImportRelativeTime } from 'api';

export const findPricePolicy = createAsyncThunk(
  'pricePolicy/findPricePolicy',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await PricePolicyApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createPricePolicy = createAsyncThunk(
  'pricePolicy/createPricePolicy',
  async (body: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await PricePolicyApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updatePricePolicy = createAsyncThunk(
  'pricePolicy/updatePricePolicy',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await PricePolicyApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  googleSheetUrl: string;
  sheetName: string;
  importMethod: number;
  importType: number;
  importTime: PricePolicyImportRelativeTime;
  isAutoImportEnabled: boolean;
  savedPagination: any;
  savedList: Array<any>;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
  googleSheetUrl: '',
  sheetName: '',
  importType: 0,
  importMethod: 2,
  importTime: {},
  isAutoImportEnabled: true,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const pricePolicySlice = createSlice({
  name: 'pricePolicy',
  initialState,
  reducers: {
    reloadPricePolicy(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    setImportPropertyPricePolicy(state, action) {
      const {
        googleSheetUrl,
        sheetName,
        importMethod,
        importType,
        importTime,
        isAutoImportEnabled,
      } = action.payload;

      state.googleSheetUrl = googleSheetUrl;
      state.sheetName = sheetName;
      state.importMethod = importMethod;
      state.importType = importType;
      state.importTime = importTime;
      state.isAutoImportEnabled = isAutoImportEnabled;
    },
    updateSavedPaginationPricePolicy(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListPricePolicy(state, action) {
      state.savedList = action.payload;
    },
    clearImportSettingPricePolicy(state) {
      state.googleSheetUrl = '';
    },
  },
  extraReducers: builder => {
    builder.addCase(findPricePolicy.fulfilled, (state, action) => {
      const { data } = action.payload;

      const newData = data.map(item => {
        return {
          ...item,
          key: item.id,
          value: item.id,
        };
      });

      state.list = newData;
    });
  },
});

const { actions, reducer: pricePolicyReducer } = pricePolicySlice;

export const {
  reloadPricePolicy,
  setImportPropertyPricePolicy,
  updateSavedPaginationPricePolicy,
  updateSavedListPricePolicy,
  clearImportSettingPricePolicy,
} = actions;

export default pricePolicyReducer;
